<template>
  <div class="BoxWide"  >
    <div class="RegistroInterventi">
      <div class="TabellaRegistro">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td class="TRCod">
                <div class="TRIndex">
                  <div>Codice intervento</div>
                  <div>{{ intervento.CodiceIntervento }}</div>
                </div>
              </td>
              <td class="TREff">
                <div class="TRIndex Bordered">
                  <div>Data Prevista</div>
                  <div>{{ this.formatDate(intervento.DataDaEffettuarsiEntro) }}</div>
                </div>
              </td>
              <td class="TRTip">
                <div class="TRIndex">
                  <div>Tipo</div>
                  <div>{{ intervento.Tipo ?? "-" }}</div>
                </div>
              </td>
              <td class="TRRic">
                <div class="TRIndex">
                  <div>Data/Richiesto da</div>
                  <div>{{ this.formatDateNoOre(intervento.DataAssegnazione) + " - " + intervento.FirmaAssegnazione ?? " "}}</div>
                </div>
              </td>
              <td class="TRSit">
                <div class="TRIndex">
                  <div>Sito / Unità</div>
                  <div>{{ this.$store.getters.getDescrizioneOperativa(intervento.CodiceSito) ?? "-" }}</div>
                </div>
              </td>
              <td class="TRSta">
                <div class="TRIndex">
                  <div>Stato</div>
                  <div> 
                    Preso in carico
                    <Popper>  
                        <a class="fancybox.iframe FancySizes InfoPopUpOpen" style="font-size: 13px; text-transform: lowercase;">i</a>                        
                        <template #content>
                          <label for="noteAsseganz">Note Assegnazione:</label>
                          <p id = "noteAsseganz" class="noteInfo">{{intervento.NoteAssegnazione ?? "-" }}</p>
                          <br>
                          <hr>
                          <br>
                          <label for="notePresaInCarico">Note presa in Carico:</label>
                          <p id ="notePresaInCarico" class="noteInfo">{{intervento.NotePresaInCarico ?? "-" }}</p>
                          <br>
                          <label for = "dataPresaInCarico">Data:</label>
                          <p id = "dataPresaInCarico">{{this.formatDateNoOre(intervento.DataPresaInCarico) ?? "-"}}</p>
                          <br>
                          <label for ="utentePresaInCarico">Utente:</label>
                          <p id = "utentePresaInCarico">{{intervento.FirmaPresaInCarico}}</p>
                        </template>
                    </Popper>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ToggleButton">
        <div class="Dettagli Button Iconed Stroked Toggled ExtraSmall">
          <span @click="this.mostraDettagli(index, intervento.CodiceIntervento, intervento.SysChiaveglobale, $event)">Checklist</span>
        </div>
      </div>
      <div class="ToggleButton">
        <div class="Gestione Button Iconed Stroked Toggled ExtraSmall">
          <span @click="this.openGestione(index,intervento.SysChiaveglobale, $event)">Gestione</span>
        </div>
      </div>
    </div>
    <div class="PannelloDettagli" style="display:none;" :id="'pannDett' + index">      
          <keep-alive>
            <component 
            :is="currentPannDett"
            :codiceIntervento="intervento.CodiceIntervento"
            :chiaveIntervento = "this.chiaveIntervento"        
            ></component>
          </keep-alive>
    </div> 
    <div class="PannelloGestione" style="display:none;" :id="'pannGest' + index">      
    <keep-alive>
        <component
        :is="currentPannGest"
        :intervento="intervento"
        :indexIntervento="index"
        >
        </component> 
    </keep-alive>    

    </div>
  </div>
  <!-- Fine repeater -->
</template>


<script>

import {dateMixin, griglieInterventiMixin, apiMixin} from "/mixin.js";
import PannDettInterventiInCorso from "@/components/PannDettInterventiInCorso.vue";
import PannGestInterventiInCorso from "@/components/PannGestInterventiInCorso.vue";
import EmptyComponent from "@/components/EmptyComponent.vue";
import Popper from "vue3-popper";

export default {
    name: "RigaIntervento",
    props: {
        index: Number,
        intervento: Object
    },
      data(){
        return{
          listaAttivita: [],                 
          chiaveIntervento: "",
          isClosingDett: true,
          isClosingGest: true
        }
  },

  components:{
    PannDettInterventiInCorso,
    PannGestInterventiInCorso,
    EmptyComponent,
    Popper
  },  

  computed: {
    currentPannDett(){ 
      let comp =  this.isClosingDett ? "EmptyComponent" : "PannDettInterventiInCorso";           
      return comp;
    },
    currentPannGest(){ 
      let comp =  this.isClosingGest ? "EmptyComponent" : "PannGestInterventiInCorso";            
      return comp;
    },
  },
  mixins: [apiMixin, dateMixin, griglieInterventiMixin],
  methods: {
    openGestione: function(index, chiaveIntervento, e){
        
        this.chiaveIntervento = chiaveIntervento;
        var el = e.srcElement.parentElement;

        if($(el).parent().parent().parent().hasClass('ChiusuraGestione')){
            this.isClosingGest = true;           
        }  
        else{
            this.isClosingGest = false;
        }
        
        this.gestisciTabDettagli(el, index, "pannGest", 'AperturaGestione', 'ChiusuraGestione');
    },   
  },
}
</script>

<style>
:root {
    --popper-theme-background-color: #ffffff;
    --popper-theme-background-color-hover:	#ffffff;
    --popper-theme-text-color:	inherit;
    --popper-theme-border-width:	1px;
    --popper-theme-border-style:	solid;
    --popper-theme-border-color:	#e10712;
    --popper-theme-border-radius:	6px;
    --popper-theme-padding:	16px;
    --popper-theme-box-shadow:	0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>